// Google Analytics 4

export default {
  event: function (eventName) {
    window.gtag('event', eventName)
  }
}
